import React, { useState } from 'react';
import { X, Info, Loader2, CheckCircle2 } from 'lucide-react';

const PLATFORM_CONFIGS = {
    telegram: {
        title: 'Bind Telegram Channel',
        fields: [
            { name: 'token', label: 'Bot Token', placeholder: '123456:ABC-DEF...', help: 'Obtain via @BotFather' },
            { name: 'chatId', label: 'Channel ID', placeholder: '@yourchannel', help: 'Make sure the bot is set as admin' }
        ]
    },
    bluesky: {
        title: 'Bind Bluesky Account',
        fields: [
            { name: 'handle', label: 'Handle', placeholder: 'username.bsky.social', help: 'Your full username' },
            { name: 'token', label: 'App Password', placeholder: 'xxxx-xxxx-xxxx-xxxx', help: 'Generate in Settings → App Passwords' }
        ]
    }
};


const TokenSubmitModal = ({ platform, isOpen, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    if (!isOpen || !platform) return null;

    const config = PLATFORM_CONFIGS[platform.toLowerCase()];

    const handleInputChange = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await onSubmit(platform, formData);
            onClose();
        } catch (err) {
            setError(err.message || 'Validation failed. Please check your input.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="w-full max-w-md bg-white rounded-2xl shadow-xl overflow-hidden">
                {/* Header */}
                <div className="px-6 py-4 border-b flex items-center justify-between bg-gray-50">
                    <h3 className="text-lg font-bold text-gray-800">
                        {config?.title || 'Configure Account'}
                    </h3>
                    <button onClick={onClose} className="p-1 hover:bg-gray-200 rounded-full transition-colors">
                        <X size={20} className="text-gray-500" />
                    </button>
                </div>

                {/* Body */}
                <form onSubmit={handleSubmit} className="p-6 space-y-5">
                    {config?.fields.map((field) => (
                        <div key={field.name} className="space-y-2">
                            <label className="text-sm font-semibold text-gray-700 flex items-center gap-1">
                                {field.label}
                            </label>
                            <input
                                required
                                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:outline-none transition-all"
                                placeholder={field.placeholder}
                                value={formData[field.name]}
                                onChange={(e) => handleInputChange(field.name, e.target.value)} />
                            <p className="text-xs text-gray-400 flex items-center gap-1">
                                <Info size={12} /> {field.help}
                            </p>
                        </div>
                    ))}

                    {error && (
                        <div className="p-3 bg-red-50 text-red-600 text-sm rounded-lg border border-red-100">
                            {error}
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="flex gap-3 pt-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:bg-red-400 flex items-center justify-center gap-2 transition-colors"
                        >
                            {loading ? <Loader2 className="animate-spin" size={18} /> : <CheckCircle2 size={18} />}
                            Confirm Binding
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default TokenSubmitModal;